import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    private readonly authService = inject(AuthService);
    private readonly router = inject(Router);


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // if user is authenticated, return true immediately
        return this.authService.token().then(t => {
            if (t) return true;

            // not logged in so redirect to login page with the return url
            else {
                this.exit();
                return false;
            }
        })
            .catch(err => {
                this.exit();
                return false;
            });
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

    exit() {
        this.router.navigate(["/login"]);
    }
}
